/** Protected learner requests share one presentation outcome. The original
 * response remains readable by callers for their existing error handling. */
export const LEARNER_ACCESS_ENDED_EVENT = 'recreated:learner-access-ended';

export async function learnerFetch(input: RequestInfo | URL, init?: RequestInit): Promise<Response> {
  const startedAt = performance.now();
  const signal = init?.signal ?? (input instanceof Request ? input.signal : undefined);
  const response = await fetch(input, init);
  if (response.status === 403 && !signal?.aborted) {
    const body = await response.clone().json().catch(() => null);
    if (!signal?.aborted && body?.code === 'access_ended' && typeof window !== 'undefined') {
      window.dispatchEvent(new CustomEvent(LEARNER_ACCESS_ENDED_EVENT, { detail: { startedAt } }));
    }
  }
  return response;
}
